module.exports = __webpack_public_path__ + "static/feat_journey_screen-89c9256d3ba4a52268862570241beb35.png";